<template>
  <svg
    class="icon fill-current"
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4619 14.152C16.7029 13.341 15.2827 12.1211 15.2827 8.125C15.2827 5.08984 13.1425 2.66016 10.2565 2.06406V1.25C10.2565 0.559766 9.69398 0 9.0002 0C8.30641 0 7.74384 0.559766 7.74384 1.25V2.06406C4.85792 2.66016 2.71764 5.08984 2.71764 8.125C2.71764 12.1211 1.29747 13.341 0.538471 14.152C0.302758 14.4039 0.198258 14.7051 0.200222 15C0.204544 15.6406 0.710149 16.25 1.46129 16.25H16.5391C17.2902 16.25 17.7962 15.6406 17.8002 15C17.8021 14.7051 17.6976 14.4035 17.4619 14.152V14.152ZM2.85318 14.375C3.68682 13.2824 4.59825 11.4715 4.60257 8.14766C4.60257 8.13984 4.60021 8.13281 4.60021 8.125C4.60021 5.70859 6.56999 3.75 9.0002 3.75C11.4304 3.75 13.4002 5.70859 13.4002 8.125C13.4002 8.13281 13.3978 8.13984 13.3978 8.14766C13.4021 11.4719 14.3136 13.2828 15.1472 14.375H2.85318ZM9.0002 20C10.3878 20 11.5133 18.8809 11.5133 17.5H6.4871C6.4871 18.8809 7.61263 20 9.0002 20Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'NotificationIcon'
}
</script>
